import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Plan } from '@qaroni-app/payments/types/plan';

@Component({
  selector: 'qaroni-payments-card',
  templateUrl: './payments-card.component.html',
  styleUrls: ['./payments-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PaymentsCardComponent {
  readonly isMonthly = input<boolean>(true);
  readonly hideSubscribeButton = input<boolean>(false);
  readonly plans = input<Plan[]>([]);
}
